var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-authi grey lighten-5"},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',[_c('Login')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }